// Actions
export const actionTypes = {
  SET_DROPDOWN: 'searchBar/SET_DROPDOWN'
}

// Action creators
export const setDropdown = () => {
  return {
    type: actionTypes.SET_DROPDOWN
  }
}




// WEBPACK FOOTER //
// ./src/actions/menu.js